module.exports = __webpack_public_path__ + "img/sp01.d61b1774.png";